import { render, staticRenderFns } from "./Vat.vue?vue&type=template&id=c0ef8890"
import script from "./Vat.vue?vue&type=script&setup=true&lang=js"
export * from "./Vat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports